import React from "react";
import * as PATHS from "../utils/paths";
import Home from "../views/homepage";
import Shop from "../views/shop"
import About from "../views/about"
import Detail from "../views/detail"

interface routeProps {
  path: string;
  element: any;
  key: number;
  title: string;
}

const routes: routeProps[] = [
  {
    key: 1,
    path: PATHS.HOMEPAGE,
    element: <Home />,
    title: "INICIO",
  },
  {
    key: 2,
    element: <Shop />,
    path: PATHS.SHOP,
    title: "PRODUCTOS",
  },
  {
    key: 3,
    element: <About />,
    path: PATHS.ABOUT,
    title: "NOSOTROS",
  },
  {
    key: 4,
    element: <Detail/>,
    path: PATHS.DETAIL,
    title: "DETALLE",
  }
];

export default routes;
